<div class="item">
  <button
    class="label"
    (click)="signatureDialog()"
    [disabled]="checkStatus() !== 'OPEN'"
  >
    <img class="icon" src="../../../../../../assets/icons/sign.png" alt="" />

    <span class="oa-title"
      >{{ action.action_name }}
      <img
        *ngIf="checkStatus() == 'OPEN' || (deferred && checkStatus() !== 'DONE')"
        src="../../../../../../../../assets/icons/{{
          'Tag_to_do.svg' | translate
        }}"
        alt=""
      />
    </span>
  </button>

  <div
    *ngIf="checkStatus() !== 'OPEN' && checkStatus() !== 'DONE'"
    class="actions"
  >
    <button
      *ngIf="showDeferButton"
      type="button"
      class="defer-link"
      data-testid="oa-signature-defer"
      [disabled]="deferring"
      (click)="continueLater()"
    >
      {{ 'ContinueLater' | translate }}
    </button>
    <mat-icon
      class="info"
      [matTooltip]="
        checkStatus() === 'PENDING' ? infoPendingMessage : blockedTooltip
      "
      >info</mat-icon
    >
  </div>
  <div *ngIf="checkStatus() == 'OPEN'" class="actions">
    <button
      *ngIf="showDeferButton"
      type="button"
      class="defer-link"
      data-testid="oa-signature-defer-open"
      [disabled]="deferring"
      (click)="continueLater()"
    >
      {{ 'ContinueLater' | translate }}
    </button>
  </div>
  <div *ngIf="checkStatus() == 'DONE'" class="actions">
    <mat-icon class="success">done</mat-icon>
  </div>
</div>
